@use "@fukuri-admins/ui/layout" as *;

.container {
  width: 100%;
}

.remindButtonWrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: spacing("16");
}

.inquiryAlertWrapper {
  margin-top: spacing("16");
}

.completeActionWrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: spacing("8");
  gap: spacing("16");
}

.branchLink {
  display: flex;
  align-items: center;
  gap: spacing("4");
  color: text('Link');
  text-decoration: none;
  @include typography('Jp/14_W3');

  &:hover {
    text-decoration: underline;
  }
}

.tableWrapper {
  margin-top: spacing("16");
  margin-bottom: spacing("16");
}

.colNo {
  width: 80px;
}

.colStressLevel {
  width: 128px;
}

.stressLevelBadge {
  display: inline-flex;
  min-width: 32px;
  padding: spacing("2") spacing("6");
  justify-content: center;
  align-items: center;
  border-radius: borderRadius("lg");
  background: background('Red');

  .label {
    @include typography('Jp/12_W3');
    color: text('Red');
  }
}
